import styled from 'styled-components';
export var CardInfo = styled.div.withConfig({
  displayName: "CardInfo",
  componentId: "sc-1cgr9so-0"
})(["display:flex;padding:", ";color:", ";"], function (_ref) {
  var padding = _ref.padding;
  return padding ? padding : '15px';
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.font;
});